import React from 'react';
import { AppBar, Box, Toolbar, Typography } from '@mui/material';
import { useNavigate } from 'react-router';
import { dataflixPalette } from '../theme/dataflix';
import { brand } from '../brand';
import BrandMark from './BrandMark';

/**
 * The bar above the interview.
 *
 * It used to hold the `<elevenlabs-convai>` widget — a third party's floating
 * control, in a strip above the page, which the instructions had to point
 * people at. The conversation is a button on the page now, driven by
 * `@elevenlabs/react`, so this is a header again and nothing more.
 */
const StartInterviewHeader = () => {
  const navigate = useNavigate();

  return (
    <AppBar
      position="static"
      elevation={0}
      sx={{
        backgroundColor: (theme) => dataflixPalette(theme).navBg,
        color: (theme) => dataflixPalette(theme).navText,
        borderBottom: (theme) => `1px solid ${dataflixPalette(theme).line}`,
      }}
    >
      <Toolbar>
        <Box
          sx={{ display: 'flex', alignItems: 'center', gap: 1.5, cursor: 'pointer' }}
          onClick={() => navigate('/careers')}
        >
          <BrandMark size={32} />
          <Box sx={{ lineHeight: 1.1 }}>
            <Typography variant="subtitle1" sx={{ fontWeight: 700, lineHeight: 1.1 }}>{brand.name}</Typography>
            {!brand.employer && <Typography variant="caption" sx={{ color: 'text.secondary', lineHeight: 1.1 }}>Personal Assistant</Typography>}
          </Box>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default StartInterviewHeader;
